import { cityStatePageSchema } from '@ecomm/city-state-data'
import {
  useAffirmBannerQuery,
  useComparisonTableQuery,
  useConfidenceBarQuery,
  useExpertSectionAssetQuery,
  useGuaranteeAssetQuery,
  useGuaranteeCopyQuery,
  useQuoteWizardQuery
} from '@ecomm/lander'
import { graphql, useStaticQuery } from 'gatsby'
import { useBenefitsTextQuery } from './useBenefitsTextQuery'

const staticQuery = graphql`
query CityStatePageQuery {
  contentfulAffirmBanner(
    contentful_id: { eq: "4VmV1UBXepTJFhRn8xKvni" }
  ) {
    description {
      raw
    }
    title
    internal {
      type
    }
  }
  guaranteeCopy: contentfulJson(
    contentful_id: { eq: "5bXaWtcoGF04HVmWb5Kuoe" }
  ) {
    content {
      internal {
        content
      }
    }
  }
  guaranteeAsset: contentfulAsset(
    contentful_id: { eq: "5FRJNkZAaZL4mHk6vuMNVb" }
  ) {
    gatsbyImageData(placeholder: BLURRED)
    description
  }
  expertSectionAsset: contentfulAsset(
    contentful_id: { eq: "4l8DenaxSNBl1LH3mmDLMv" }
  ) {
    gatsbyImageData(placeholder: BLURRED)
  }
  comparisonTable: contentfulJson(
    contentful_id: { eq: "18qXWQrIu5vaqsUScRFNeI" }
  ) {
    content {
      internal {
        content
      }
    }
  }
  quoteWizardAsset: contentfulAsset(
    contentful_id: { eq: "7FApwfEA91pNmqu35jzIoy" }
  ) {
    gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    description
  }
  benefitsImages: allContentfulAsset(
    filter: {
      contentful_id: {
        in: ["4ybJ9ftX9ynMSD5tnEiAcV", "7e1hT6DJeh1F38xbRkYxY4"]
      }
    }
  ) {
    nodes {
      gatsbyImageData(placeholder: BLURRED)
    }
  }
}
`

export const useCityStatePageQuery = () => {
  const quoteWizard = useQuoteWizardQuery('6wRdF53o74w2MhOhBIkzip')
  const staticData = useStaticQuery(staticQuery) || {}
  return cityStatePageSchema.parse({ ...staticData, quoteWizard })
}

export const useStaticData = (region: string) => {
  const guaranteeAsset = useGuaranteeAssetQuery()
  const benefitsText = useBenefitsTextQuery(region)
  const guaranteeCopy = useGuaranteeCopyQuery()
  const confidenceBarData = useConfidenceBarQuery('5ynnx5XFY9LYRUyZEkN98K')
  const affirmData = useAffirmBannerQuery()
  const expertSectionAssetData = useExpertSectionAssetQuery()
  const { comparisonTable } = useComparisonTableQuery('18qXWQrIu5vaqsUScRFNeI')

  return {
    affirmData,
    guaranteeAsset,
    confidenceBarData,
    benefitsText,
    guaranteeCopy,
    expertSectionAssetData,
    comparisonTable
  }
}
